<template>
  <v-card v-if="user"
          class="mb-4">
    <v-card-title>
      <v-icon left
              color="primary">
        fas fa-fw fa-address-book
      </v-icon>
      {{ isCurrentUser ? 'My Contacts' : 'Contacts' }}
    </v-card-title>
    <v-card-text>
      <h3 class="text-h6 mb-3">Default Greeting Style</h3>
      <p class="text-body-2 text--secondary mb-4">
        Choose how you want to address your contacts in emails.
      </p>
      <v-radio-group v-model="form.default_greeting_type"
                     dense
                     class="mt-0">
        <v-radio v-for="greetingType in greetingTypes"
                 :key="greetingType.id"
                 :value="greetingType.id">
          <template v-slot:label>
            <div>
              <div class="font-weight-medium">{{ greetingType.name }}</div>
              <div class="text-caption text--secondary mt-1">
                {{ greetingType.hint }}
              </div>
            </div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-alert
        type="info"
        text
        dense
        class="mt-4"
        icon="fas fa-info-circle"
      >
        <div class="text-caption">
          <strong>How it works:</strong>
          <span v-if="greetingType === 'professional'">
                                    Contacts will be addressed using their salutation and last name when available (e.g., "Dr. Smith").
                                    If no salutation is provided, their full name will be used (e.g., "John Smith").
                                </span>
          <span v-else>
                                    Contacts will be addressed by their first name for a more personal touch.
                                </span>
          You can always override this setting for individual contacts.
        </div>
      </v-alert>

      <!-- Examples section -->
      <v-card outlined class="mt-4 pa-4">
        <div class="text-subtitle-2 mb-3">
          <i class="fas fa-eye mr-1"></i>
          Preview Examples
        </div>

        <div class="mb-3">
          <div class="text-body-2 font-weight-medium mb-1">Sample Contact: Dr. Sarah Johnson, MD</div>
          <div class="text-body-2 d-flex">
            <div class="text--secondary mr-2">
              Greeting:
            </div>
            <div v-if="isFormal"
                 class="font-weight-medium">
              "Dear Dr. Johnson"
            </div>
            <div v-else
                 class="font-weight-medium">
              "Dear Sarah"
            </div>
          </div>
        </div>

        <div>
          <div class="text-body-2 font-weight-medium mb-1">
            Sample Contact: Mark Thompson (no salutation)
          </div>
          <div class="text-body-2 d-flex">
            <div class="text--secondary mr-2">
              Greeting:
            </div>
            <div v-if="isFormal"
                 class="font-weight-medium">
              "Dear Mark Thompson"
            </div>
            <div v-else class="font-weight-medium">
              "Dear Mark"
            </div>
          </div>
        </div>
      </v-card>
    </v-card-text>


  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import userContactService from '../../../services/userContactService';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      greetingTypes: userContactService.getGreetingTypes(),
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    isFormal() {
      return this.form.default_greeting_type === 'Formal';
    },
    isCurrentUser() {
      return this.user
        && this.currentUser.id === this.user.id;
    }
  }
}
</script>
